module.exports = __webpack_public_path__ + "static/media/vrouw-die-palliatieve-zorg-krijgt-schildert-in-haar-zolder-atelier.e72b0e10.jpg";